/**
 * Calculates the active daily reward streak day shown in the UI.
 * Mirrors server UTC-day claim logic to avoid stale streak displays.
 */
export const getRealActiveStreak = (
  dailyClaimStreak: number,
  lastDailyClaimAt: string | null
): number => {
  if (!lastDailyClaimAt) return 1;

  const lastClaim = new Date(lastDailyClaimAt);
  if (Number.isNaN(lastClaim.getTime())) return 1;

  const now = new Date();
  const todayUTC = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const yesterdayUTC = todayUTC - 24 * 60 * 60 * 1000;
  const lastClaimDayUTC = Date.UTC(
    lastClaim.getUTCFullYear(),
    lastClaim.getUTCMonth(),
    lastClaim.getUTCDate()
  );

  if (lastClaimDayUTC === todayUTC) {
    return Math.max(1, dailyClaimStreak);
  }

  if (lastClaimDayUTC === yesterdayUTC) {
    return dailyClaimStreak + 1;
  }

  return 1;
};
